var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldMessageFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.03 1C16.76 1 16 1.76 16 3.03v2.94C16 7.24 16.76 8 18.03 8h2.94C22.24 8 23 7.24 23 5.97V3.03C23 1.76 22.24 1 20.97 1h-2.94zm1.47 5.5c-.45 0-1.73-.62-2.11-1.82-.06-.18-.09-.38-.09-.57 0-.65.33-1.32 1.02-1.54.41-.13.85-.06 1.16.2.32-.25.76-.33 1.18-.2.92.29 1.21 1.32.95 2.11-.37 1.18-1.66 1.82-2.11 1.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.97V3c0-.55-.45-1-1-1H7C4.24 2 2 4.23 2 6.98v6.97c0 2.76 2.24 5 5 5h1.5c.28 0 .64.18.8.4l1.5 1.99c.66.88 1.74.88 2.4 0l1.5-1.99c.19-.25.49-.4.8-.4h1.51c2.76 0 4.99-2.23 4.99-4.99V10.5c0-.55-.45-1-1-1h-2.97a3.53 3.53 0 0 1-3.53-3.53zM7 11c0-.55.44-1 1-1 .55 0 1 .45 1 1s-.44 1-1 1-1-.45-1-1zm4 0c0-.55.44-1 1-1 .55 0 1 .45 1 1s-.44 1-1 1-1-.45-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMessageFavorite);
export default __webpack_public_path__ + "static/media/vuesax-bold-message-favorite.81360a778a8d15998b4cb317009ffc97.svg";
export { ForwardRef as ReactComponent };